import { render, staticRenderFns } from "./activities-detail.vue?vue&type=template&id=3b529dcb&"
import script from "./activities-detail.vue?vue&type=script&lang=js&"
export * from "./activities-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports